export enum FHIR_QUESTIONNAIRE_MODULE_ASSET_KEYS {}

export type FHIRQuestionnaireModuleAssets = Record<
  FHIR_QUESTIONNAIRE_MODULE_ASSET_KEYS,
  unknown
>;

export const FHIR_QUESTIONNAIRE_MODULE_ASSETS_MAP: FHIRQuestionnaireModuleAssets =
  {};
